import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'

@Component({
	selector: 'course-duration',
	templateUrl: './course-duration.component.html',
	styleUrls: ['./course-duration.component.scss']
})

export class CourseDurationComponent implements OnChanges, OnDestroy {

	@Input() course = 0
	
	courseDurationLoading = false
	
	unitsNum = 0
	unitsTime = 0
	unitsReq = false
	
	lessonsNum = 0
	
	objNum = 0
	objTime = 0
	objReq = false
	
	summariesNum = 0
	summariesTime = 0
	summariesReq = false
	
	testsNum = 0
	testsTime = 0
	testsReq = false
	
	cpNum = 0
	cpTime = 0
	cpReq = 0
	
	activitiesNum = 0
	activitiesTime = 0
	activitiesReq = false
	
	headingsNum = 0
	headingsTime = 0
	
	totalTime = 0
	totalTimeHours = 0
	totalTimeHoursCourse = 0
	
	courseDurationDetail: any[] = []

	getCourseDurationSub = new Subscription

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService) { }

	ngOnChanges(): void {
		this.courseDurationLoading = true

		this.getCourseDurationSub = this.dataService.getCourseDuration(this.course)
		.subscribe(
			data => {
				// console.log(data)
				this.courseDurationLoading = false
				this.unitsNum = data.unitsNum
				this.unitsTime = data.unitsTime
				this.unitsReq = data.unitsReq
				this.lessonsNum = data.lessonsNum
				this.objNum = data.objNum
				this.objTime = data.objTime
				this.objReq = data.objReq
				this.summariesNum = data.summariesNum
				this.summariesTime = data.summariesTime
				this.summariesReq = data.summariesReq
				this.testsNum = data.testsNum
				this.testsTime = data.testsTime
				this.testsReq = data.testsReq
				this.cpNum = data.cpNum
				this.cpTime = data.cpTime
				this.cpReq = data.cpReq
				this.activitiesNum = data.activitiesNum
				this.activitiesTime = data.activitiesTime
				this.activitiesReq = data.activitiesReq
				this.headingsNum = data.headingsNum
				this.headingsTime = data.headingsTime
				this.totalTime = data.totalTime
				this.totalTimeHours = data.totalTimeHours
				this.totalTimeHoursCourse = data.totalTimeHoursCourse
				this.courseDurationDetail = data.courseDurationDetail
			},
			_error => {
				// console.log(error)
			}
		)
	}

	ngOnDestroy(): void {
		this.getCourseDurationSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}
}
